import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogOut } from "../reducers/commonReducer";
import staticLogo from "../images/logo.png";
import {
  branchs,
  chatUsers,
  dashboard,
  home,
  messages,
  quickReply,
  settings,
  uploadedFiles,
  users,
  broadcast,
} from "../const";
import { Button } from "react-bootstrap";
import socket from "../socketInstance";
import UpdateMyPassword from "../UpdateMyPassword";
import NotificationBell from "./NotificationBell";

const siteLogo = process.env.REACT_APP_SITE_LOGO || staticLogo;

const SideMenu = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [inactive, setInactive] = useState(false);
  const logOut = () => {
    if (socket.connected) {
    socket.disconnect();
    console.log("🔌 Socket disconnected");
  }
    dispatch(
      userLogOut({ "x-auth-token": localStorage.getItem("x-auth-token") })
    );
    localStorage.clear();
    navigate(home);
    window.location.reload();
  };
  return (
    <>
      <div className="row print-hide">
        <div className="col">
          <div className={`side-menu ${inactive ? "inactive" : ""}`}>
            <div className="top-section">
              <div className="logo">
                <img src={siteLogo} alt="Site Logo" />
              </div>
              <ul className="nav side-links fs-3 mt-1  flex-column">
                {localStorage.getItem("x-auth-token") &&
                  localStorage.getItem("slug") == "admin" && (
                    <>
                      <NavLink to={branchs}>
                        {inactive ? (
                          <i className="bi bi-people me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            {" "}
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people me-2 ds"></i>
                                Branch
                                <hr />
                              </span>
                            </li>{" "}
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={users}>
                        {inactive ? (
                          <i className="bi bi-people me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            {" "}
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people me-2 ds"></i>
                                Users
                                <hr />
                              </span>
                            </li>{" "}
                          </span>
                        )}
                      </NavLink>
                      <NavLink to="/admin-group-chats">
                        {inactive ? (
                          <i className="bi bi-people-fill me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people-fill me-2 ds"></i>
                                Groups
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={uploadedFiles}>
                        {inactive ? (
                          <i className="bi bi-people me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            {" "}
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people me-2 ds"></i>
                                Uploaded Files
                                <hr />
                              </span>
                            </li>{" "}
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={quickReply}>
                        {inactive ? (
                          <i className="bi bi-people me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            {" "}
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people me-2 ds"></i>
                                Quick Reply
                                <hr />
                              </span>
                            </li>{" "}
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={settings}>
                        {inactive ? (
                          <i className="bi bi-gear me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            {" "}
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-gear me-2 ds"></i>
                                Settings
                                <hr />
                              </span>
                            </li>{" "}
                          </span>
                        )}
                      </NavLink>
                      {/* old */}
                    </>
                  )}
                {localStorage.getItem("x-auth-token") &&
                  localStorage.getItem("slug") == "branch_leader" && (
                    <>
                      <NavLink to={chatUsers}>
                        {inactive ? (
                          <i className="bi bi-chat-dots me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-chat-dots me-2 ds"></i>
                                Chat
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={users}>
                        {inactive ? (
                          <i className="bi bi-people me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            {" "}
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people me-2 ds"></i>
                                Users
                                <hr />
                              </span>
                            </li>{" "}
                          </span>
                        )}
                      </NavLink>
                      <NavLink to="/admin-group-chats">
                        {inactive ? (
                          <i className="bi bi-people-fill me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people-fill me-2 ds"></i>
                                Groups
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      {/* old */}
                    </>
                  )}
                {localStorage.getItem("x-auth-token") &&
                  localStorage.getItem("slug") == "team_leader" && (
                    <>
                      <NavLink to={chatUsers}>
                        {inactive ? (
                          <i className="bi bi-chat-dots me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-chat-dots me-2 ds"></i>
                                Chat
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={`${chatUsers}?createGroup=true`}>
                        {inactive ? (
                          <i className="bi bi-people-fill me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people-fill me-2 ds"></i>
                                Create Group
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={quickReply}>
                        {inactive ? (
                          <i className="bi bi-lightning-charge me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-lightning-charge me-2 ds"></i>
                                Quick Reply
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={broadcast}>
                        {inactive ? (
                          <i className="bi bi-megaphone me-2"></i>
                        ) : (
                          <span className="border-bottom">
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-megaphone me-2 ds"></i>
                                Broadcast
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                    </>
                  )}
              </ul>
            </div>
          </div>
        </div>

        <div className="col">
          <div className={`${inactive ? "content-active" : "content"}`}>
            <div className="d-flex justify-content-between bg-themesecond border-dark border-bottom">
              <div className="p-2"></div>
              <div className="p-2">
                {localStorage.getItem("x-auth-token") && <span className="me-2 d-inline-block"><NotificationBell /></span>}
                {/* <Button className="btn mx-1" variant="warning">
                  <Link to="/my-profile">
                    <span className="nav-link">
                      <i className="bi text-white bi-person-fill"></i>
                    </span>
                  </Link>
                </Button> */}
                <UpdateMyPassword/>
                {localStorage.getItem("x-auth-token") && <Button
                  onClick={logOut}
                  className="btn btn-outline-primary"
                  variant="danger"
                >
                  <span
                    className="nav-link text-white"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Log Out
                  </span>
                </Button>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
